// extracted by mini-css-extract-plugin
module.exports = {"review-stars-link":"ReviewStarsWithCounter_review-stars-link__1WUGh"};